import initMainSearchBox from 'js/scenes/MainSearchBox';
import { renderHeaderBlock } from 'js/subHeader';
import { fontLoadObserver } from 'js/fontsLoad';
import renderMegaMenu from 'js/components/megaMenu/MegaMenu';
import decryptStr from 'js/helpers/decrypt';

import 'js/trusted-security-policies';
import './index.scss';

window.renderHeaderBlock = renderHeaderBlock;
window.renderMegaMenu = renderMegaMenu;
window.fontLoadObserver = fontLoadObserver;
window.initMainSearchBox = initMainSearchBox;
window.decryptStr = decryptStr;
